import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    Output
} from '@angular/core';

@Component({
    selector: 'calendar-day',
    template: `
        <span
            class="day-container"
            (click)="handleClick($event)"
            (mouseenter)="handleMouseEnter($event)"
            [ngClass]="dayContainerClassList"
            [hidden]="hidden"
        >
            <span class="day-inner" [ngClass]="dayInnerClassList">
                {{ date.getDate() }}
            </span>
        </span>
    `,
    styleUrls: ['./calendar-day.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CalendarDayComponent implements OnChanges {
    @Input() public date = new Date();
    @Input() public selected = false;
    @Input() public isStartOfRange = false;
    @Input() public withinRange = false;
    @Input() public isEndOfRange = false;
    @Input() public disabled = false;
    @Input() public muted = false;
    @Input() public hidden = false;
    @Input() public isToday = false;
    @Input() public rangeHovered = false;
    @Input() public isRangeHoveredStart = false;
    @Input() public isRangeHoveredEnd = false;
    @Input() public isFirstDayOnCalendar = false;
    @Input() public isLastDayOnCalendar = false;
    @Output() public dayClick = new EventEmitter<Event>();
    @Output() public dayMouseEnter = new EventEmitter<Event>();

    public dayContainerClassList: string[] = [];
    public dayInnerClassList: string[] = [];

    public ngOnChanges(): void {
        this.setClassList();
    }

    public setClassList(): void {
        this._setCssClass('sunday', this.date.getDay() === 0);
        this._setCssClass('saturday', this.date.getDay() === 6);
        this._setCssClass('selected', this.selected);
        this._setCssClass('start-of-range', this.isStartOfRange);
        this._setCssClass('within-range', this.withinRange);
        this._setCssClass('end-of-range', this.isEndOfRange);
        this._setCssClass('disabled', this.disabled);
        this._setCssClass('muted', this.muted);
        this._setCssClass('hidden', this.hidden);
        this._setCssClass('today', this.isToday);
        this._setCssClass('range-hovered', this.rangeHovered);
        this._setCssClass('range-hovered-start', this.isRangeHoveredStart);
        this._setCssClass('range-hovered-end', this.isRangeHoveredEnd);
        this._setCssClass('first-day-on-calendar', this.isFirstDayOnCalendar);
        this._setCssClass('last-day-on-calendar', this.isLastDayOnCalendar);
    }

    private _getDayInnerClassName(className: string): string {
        return `day-inner-${className}`;
    }

    private _setCssClass(className: string, condition: boolean): void {
        const dayInnerClassName = this._getDayInnerClassName(className);
        const dayContainerIndex = this.dayContainerClassList.indexOf(className);
        const dayInnerIndex = this.dayInnerClassList.indexOf(dayInnerClassName);
        if (condition) {
            if (dayContainerIndex === -1) {
                this.dayContainerClassList.push(className);
            }
            if (dayInnerIndex === -1) {
                this.dayInnerClassList.push(dayInnerClassName);
            }
        } else {
            if (dayContainerIndex > -1) {
                this.dayContainerClassList.splice(dayContainerIndex, 1);
            }
            if (dayInnerIndex > -1) {
                this.dayInnerClassList.splice(dayInnerIndex, 1);
            }
        }
    }

    public handleMouseEnter(event: Event): void {
        if (!this.disabled && !this.hidden) {
            this.dayMouseEnter.emit(event);
        }
    }

    public handleClick(event: Event): void {
        if (!this.disabled && !this.hidden) {
            this.dayClick.emit(event);
        }
    }
}
